import { Injectable, inject } from '@angular/core';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { StatisticTypeEnum } from 'src/app/enum/statistic-type.enum';
import { StatisticService } from '../statistic.service';

@Injectable({
  providedIn: 'root',
})
export class CastofidMiniStatisticService {
  private readonly statisticService = inject(StatisticService);

  send(statisticType: StatisticTypeEnum): Promise<any> {
    return this.statisticService.sendStatistic(statisticType, 1, CONFIG_CONTEXT.CASTOFID_MINI);
  }
}
